module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "clearfix mod-hd"
  }, [_c('div', {
    staticClass: "mod-shadow"
  }), _vm._v(" "), _c('el-col', {
    staticClass: "mod-header",
    attrs: {
      "span": 24
    }
  }, [_c('el-col', {
    staticClass: "logo"
  }, [_c('div', {
    class: _vm.collapsed ? 'logo-collapse-width' : 'logo-inner'
  }, [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm.collapsed ? '' : _vm.sysName) + "\n\t\t\t\t")])]), _vm._v(" "), (!_vm.hiddenMenu) ? _c('el-col', {
    staticClass: "mod-hor-nav",
    attrs: {
      "span": 10
    }
  }, [_c('el-tabs', {
    on: {
      "tab-click": _vm.handleClick
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, _vm._l((_vm.$router.options.routes), function(item) {
    return (!item.hidden) ? _c('el-tab-pane', {
      key: item.path,
      attrs: {
        "name": item.path
      }
    }, [_c('span', {
      attrs: {
        "slot": "label"
      },
      slot: "label"
    }, [(item.iconCls) ? _c('i', {
      staticClass: "iconfontmod",
      domProps: {
        "innerHTML": _vm._s(item.iconCls)
      }
    }) : _vm._e(), _vm._v(" " + _vm._s(item.name))])]) : _vm._e()
  }))], 1) : _vm._e(), _vm._v(" "), _c('el-col', {
    staticClass: "userinfo",
    attrs: {
      "span": 2
    }
  }, [_c('el-dropdown', {
    attrs: {
      "trigger": "hover"
    }
  }, [_c('span', {
    staticClass: "el-dropdown-link userinfo-inner"
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/images/conf/login/1.0.0/user-img.png")
    }
  }), _vm._v(" " + _vm._s(_vm.sysUserName))]), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('el-dropdown-item', {
    nativeOn: {
      "click": function($event) {
        return _vm.modifyPwd($event)
      }
    }
  }, [_vm._v("修改密码")]), _vm._v(" "), _c('el-dropdown-item', {
    attrs: {
      "divided": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.logout($event)
      }
    }
  }, [_vm._v("退出账号")])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4e67d286","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/conf/index/hd.vue
// module id = 275
// module chunks = 123